<template>
  <span v-html="text"></span>
</template>

<script>
import CmsMixin from '@/mixins/CmsMixin';
/**
 * Cms Text
 *
 * A component for rendering cms text based on the given key.
 */
export default {
  name: 'CmsText',
  mixins: [
    CmsMixin,
  ],
  computed: {
    text() {
      return this.getCMSText(this.cmsKey, this.context, this.defaultValue, this.categoryId);
    },
  },
};
</script>
